module.exports = __webpack_public_path__ + "img/93.15ba1aae.png";